import React from "react";
import PropTypes from "prop-types";
import { AppRowContainer } from "@crema";
import { Col } from "antd";

function ShowProfessionalProfile({ professionalProfile }) {
  return (
    <AppRowContainer>
      <Col xs={8}>
        <p className="text-secondary">Name</p>
      </Col>
      <Col xs={16}>
        <p>{professionalProfile.professionalProfileName}</p>
      </Col>
    </AppRowContainer>
  );
}

export default ShowProfessionalProfile;

ShowProfessionalProfile.propTypes = {
  professionalProfile: PropTypes.object,
};
